import { FC } from 'react';

import Welcome from './slots/Welcome';
import imgCard1 from '../../../assets/svg/imgCard1.svg';
import imgCard2 from '../../../assets/svg/imgCard2.svg';
import imgCard3 from '../../../assets/svg/imgCard3.svg';
import imgCard4 from '../../../assets/svg/imgCard4.svg';
import Card from '../../../components/Card/Index';
import Carousel from '../../../components/Carousel';
import Btn from '../../../components/Button';
import AppConfig from '../../../config/AppConfig';
import {
  gtmAttributesUpdatePasHomePage,
  gtmAttributesSalesManagement,
  gtmAttributesAttendance,
  gtmAttributesTrainings,
  gtmAttributesFinancial,
  gtmAttributesAccessPas,
} from '../../../utils/gtmVariables';
import useGTMEventsTracker from '../../../hooks/useGTMEventsTracker';
import Container from '../../../components/Container';
import palette from '../../../theme/gcbPalette';

const Home: FC<any> = () => {
  const gtmEventsTracker = useGTMEventsTracker();
  const pasAccess = AppConfig.get('REACT_APP_LINK_CADASTRAR_SENHA');

  const accessPortal = () => {
    gtmEventsTracker(gtmAttributesAccessPas);
    if (pasAccess) window.open(pasAccess, '_blank');
  };

  gtmEventsTracker(gtmAttributesUpdatePasHomePage);

  const cards = [
    <Card
      title="Gestão de Vendas"
      subtitle="Saiba como funciona"
      color={palette.neutral.dark}
      imageUrl={imgCard1}
      body="Conheça a tela de gestão de vendas da sua loja."
      link="https://escola.via.com.br/cursos/gestao-de-vendas-conheca-a-tela-de-gestao-de-vendas"
      key="sales-management"
      onClick={() => gtmEventsTracker(gtmAttributesSalesManagement)}
    />,
    <Card
      title="Atendimento"
      subtitle="Ações que você deve tomar"
      color={palette.neutral.light}
      imageUrl={imgCard3}
      body="Saiba como fazer a gestão dos protocolos da sua loja."
      link="https://escola.via.com.br/cursos/atendimento-acoes-do-lojista"
      key="attendance"
      onClick={() => gtmEventsTracker(gtmAttributesAttendance)}
    />,
    <Card
      title="Treinamentos aplicados"
      subtitle="Cadastro de produtos"
      color={palette.neutral.light}
      imageUrl={imgCard2}
      body="Entenda como cadastrar os produtos da sua loja."
      link="https://escola.via.com.br/cursos/treinamentos-aplicados-catalogo-cadastro-de-produtos"
      key="trainings"
      onClick={() => gtmEventsTracker(gtmAttributesTrainings)}
    />,
    <Card
      title="Financeiro"
      subtitle="Fluxo de repasse"
      color={palette.neutral.dark}
      imageUrl={imgCard4}
      body="Saiba como funciona o fluxo de repasse das suas vendas."
      link="https://escola.via.com.br/cursos/financeiro-fluxo-de-repasse"
      key="financial"
      onClick={() => gtmEventsTracker(gtmAttributesFinancial)}
    />,
  ];

  return (
    <Container className="w-full max-w-screen-xl mx-auto">
      <div className="flex flex-wrap mt-6 mb-16 lg:mt-14 lg:mb-32">
        <div className="flex items-start lg:mt-16 justify-center lg:px-12 w-full lg:w-5/12">
          <Welcome />
        </div>
        <div className="hidden lg:grid grid-cols-2 gap-4 lg:mt-0 w-full lg:w-7/12">{cards}</div>
        <div className="lg:hidden mt-6 w-full">
          <Carousel items={cards} />
        </div>
        <div className="lg:hidden mt-24 w-full px-5">
          <Btn
            text="Acessar o Portal do lojista"
            type="button"
            variant="primary"
            onClick={accessPortal}
          />
        </div>
      </div>
    </Container>
  );
};

export default Home;
